const advantages = [
  { icon: 'ri-award-line', title: '18+ лет практики', desc: 'Реальный опыт в продажах, переговорах и управлении — не теория, а то, что работает.' },
  { icon: 'ri-user-star-line', title: 'Практикующий тренер', desc: 'Сам продаю свои услуги, веду переговоры и работаю с клиентами каждый день.' },
  { icon: 'ri-discuss-line', title: 'Реальные кейсы клиентов', desc: 'Разбираем звонки, переписки и ситуации из вашей компании — не придуманные примеры.' },
  { icon: 'ri-road-map-line', title: 'Работа «в поле»', desc: 'При необходимости выезжаю на совместные переговоры и звонки с менеджерами.' },
  { icon: 'ri-book-open-line', title: 'Разработка Книги продаж', desc: 'Помогаю создать корпоративные стандарты, скрипты и регламенты работы с клиентами.' },
  { icon: 'ri-building-2-line', title: 'Корпоративные стандарты', desc: 'Формирую единый стиль общения компании, который повышает доверие и конверсию.' },
  { icon: 'ri-chat-smile-3-line', title: 'Сопровождение', desc: 'Не бросаю после тренинга — помогаю внедрить изменения и довести до результата.' },
  { icon: 'ri-gamepad-line', title: 'Использую бизнес-игры', desc: 'Игровые форматы для вовлечения команды и отработки сложных переговорных ситуаций.' },
  { icon: 'ri-bar-chart-grouped-line', title: 'Работа на результат', desc: 'Фокус не на «проведённых часах», а на измеримом росте бизнес-показателей.' },
];

export default function WhyWorkWithAlexey() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему компании работают с Алексеем Сивко
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">
          Не просто бизнес-тренер — практик, который сам прошёл путь в продажах и переговорах
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
          {advantages.map((adv, i) => (
            <div key={i} className="bg-white rounded-xl p-5 hover:bg-teal-50 hover:ring-2 hover:ring-teal-200 transition-all group border border-gray-100">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className={`${adv.icon} text-base text-white`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-sm mb-1 group-hover:text-teal-700 transition-colors">
                    {adv.title}
                  </h3>
                  <p className="text-gray-600 text-xs leading-relaxed">{adv.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}